import { Row, Col, Label, ReactSelectBox, Accordion } from "client/CommonComponents";
import "./ReceivingBranch.scss";

const ReceivingBranch = (props: any) => {

  const {
    onChangeCostCenter,
    asset,
    searchCostCenter,
    costCentersBySearchList,
    ReceivingBranchFieldRef
  } = props;

  const expandedItems = [
    {
      headerText: <>
        <p className="accordion-heading receive-branch">RECEIVING BRANCH</p>
        <p className="subText">Choose asset receiving branch</p>
      </>,
      content:
        <div className="p-3">
          <Row>
            <Col xs={12} md={4} lg={4} className='mb-3'>
              <Label required data-attribute="ReceivingBranch_Default_Label">Cost Center</Label>
              <ReactSelectBox
                name='searchedCostCenter'
                placeholder='Search Cost Center'
                options={costCentersBySearchList}
                onChange={(item: any) => onChangeCostCenter(item)}
                onInputChange={searchCostCenter}
                value={asset?.receivingCostCenter}
                isSearchable={true}
                className={asset.receivingCostCenterError ? 'controlValidation' : ""}
                selectRef={(element: any) => ReceivingBranchFieldRef.current[1] = element}
               data-attribute="ReceivingBranch_searchedCostCenter_SearchSelectBox" />
              <p className='validMessage'>{asset.receivingCostCenterError}</p>
            </Col>
          </Row>
        </div>,
      uuid: "receivingBranch",
    },
  ];

  return (<>
    <Accordion
      Items={expandedItems}
      preExpanded={["receivingBranch"]}
      allowZeroExpanded
      className="custom-accordion"
     data-attribute="ReceivingBranch_Default_Accordion" />
  </>);
};

export default ReceivingBranch;
